export default function decorateLinks(
  domain: string,
  query: string,
  value: string,
) {
  const ls = document.querySelectorAll("a");
  ls.forEach(function (l) {
    if (l.href.includes(domain)) {
      const u = new URL(l.href);
      u.searchParams.set(query, value);
      l.href = u.href;
    }
  });
}
